import { EditCtrl } from "../Editor"

export default class CennikEditCtrl extends EditCtrl {

  static $inject = ["item", "saveHandler", "$rootScope"];

  constructor(item, saveHandler, $rootScope){
    super(item, saveHandler);

    this.$rootScope = $rootScope;
  }

  submit() {
    this.form.$setSubmitted();

    if (this.form.$valid) {
      let dto = {};

      for (let key of ['kod', 'nazov'])
        if (this.form[key].$dirty)
          dto[key] = this.item[key];

      this.saveHandler(this.item.id, dto).then(() => {
        this.$rootScope.back();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/Cennik/CennikEditCtrl.js